import API, { graphqlOperation } from "@aws-amplify/api";
import * as mutations from "../../graphql/mutations";
import * as queries from "../../graphql/queries";
import { makeGraphQLRequest } from "..";

const createJob = async (object) => {
  try {
    return makeGraphQLRequest(
      graphqlOperation(mutations.createCronJob, { input: object })
    );
  } catch (error) {
    console.error("Error creating Job:", error);
    throw error;
  }
};

const updateJob = async (id, args) => {
  try {
    // First, fetch the current version of the Job
    const getJobResponse = await makeGraphQLRequest(
      graphqlOperation(queries.getCronJob, { id })
    );
    const currentJob = getJobResponse.data.getCronJob;

    // Prepare the update input
    const updateInput = { id, _version: currentJob._version };
    args.forEach((arg) => {
      updateInput[arg.property] = arg.value;
    });

    return makeGraphQLRequest(
      graphqlOperation(mutations.updateCronJob, { input: updateInput })
    );
  } catch (error) {
    console.error("Error updating Job:", error);
    throw error;
  }
};

const deleteJob = async (id) => {
  try {
    // First, fetch the current version of the Job
    const getJobResponse = await makeGraphQLRequest(
      graphqlOperation(queries.getCronJob, { id })
    );
    const currentJob = getJobResponse.data.getCronJob;

    const response = await makeGraphQLRequest(
      graphqlOperation(mutations.deleteCronJob, {
        input: { id, _version: currentJob._version },
      })
    );
    return response.data.deleteCronJob;
  } catch (error) {
    console.error("Error deleting Job:", error);
    throw error;
  }
};

const getJobsByWorkspaceID = (workspaceID) =>
  makeGraphQLRequest(
    graphqlOperation(queries.cronJobsByWorkspace, {
      workspaceID: workspaceID,
    })
  );

const getJobsByAgentID = (agentID) =>
  makeGraphQLRequest(
    graphqlOperation(queries.cronJobsByAgent, {
      agentID: agentID,
    })
  );

const getJobsByPromptID = (customPromptID) =>
  makeGraphQLRequest(
    graphqlOperation(queries.cronJobsByPrompt, {
      customPromptID: customPromptID,
    })
  );

export default {
  createJob,
  updateJob,
  deleteJob,
  getJobsByWorkspaceID,
  getJobsByAgentID,
  getJobsByPromptID,
};